import { faXmark } from "@fortawesome/pro-regular-svg-icons/faXmark";
import { Box, type Theme } from "@mui/material";
import { styled, SxProps } from "@mui/material/styles";
import { ReactElement, ReactNode } from "react";
import * as React from "react";
import { FaIcon } from "../Icon/FaIcon";
import { SrChip, type SrChipProps } from "../sr-chip/sr-chip";

export interface SrFilterChipsProps {
  sx?: SxProps<Theme>;
  children: ReactNode;
}

export const SrFilterChips = ({ sx, children }: SrFilterChipsProps): ReactElement => {
  return <Box sx={sx}>{children}</Box>;
};

/**
 * Chip to display the active filter option
 */
export type SrFilterChipsItemProps = Omit<SrChipProps, "onDelete"> & {
  value: string;
  onDelete?: (v: string) => void;
};

const Item = styled(SrChip)(({ theme }) => ({
  background: "none",
  borderColor: theme.vars.palette.grey.A400,
  ...theme.typography.body2,
  textAlign: "left",
  color: theme.vars.palette.grey.A700,
  margin: "0 10px 8px 0",
  padding: "14px 8px 12px !important",
}));

const SrFilterChipsItem = ({
  label,
  value,
  variant = "outlined",
  color = "default",
  sx,
  onDelete,
  ...props
}: SrFilterChipsItemProps): React.JSX.Element => {
  return (
    <Item
      {...props}
      label={label || value}
      variant={variant}
      color={color}
      sx={sx}
      deleteIcon={
        <FaIcon
          icon={faXmark}
          sx={{
            fontSize: "15px !important",
            m: "0 4px 1px 0 !important",
            fill: (theme) => theme.vars.palette.grey.A700,
          }}
        />
      }
      onDelete={onDelete ? () => onDelete(value) : undefined}
    />
  );
};

SrFilterChips.Item = SrFilterChipsItem;
